import React from 'react';
import { translate } from 'react-i18next';
import i18next from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import sanitizeHTML from 'sanitize-html';

import messageReportHandlerEN from './locales/MessageReportHandler_en.json';
import messageReportHandlerFR from './locales/MessageReportHandler_fr.json';

import './MessageReportHandler.less';
import { UPDATE_MESSAGE_SUCCESS, RESOLVE_REPORT_SUCCESS, SANITIZE_HTML_CONFIG } from '../../messages/messageActions';

const ACTIVE = 1;
const ARCHIVED = 3;
const MESSAGE_SENT = 1;

class MessageReportHandler extends React.Component {
     constructor(props) {
        super(props);
        
        this.state = { 

        };

        i18next.addResourceBundle('en', 'MessageReportHandler', messageReportHandlerEN);
        i18next.addResourceBundle('fr', 'MessageReportHandler', messageReportHandlerFR);

        this.goBack = this.goBack.bind(this);
        this.markAsResolved = this.markAsResolved.bind(this);
        this.deleteAssociatedMessage = this.deleteAssociatedMessage.bind(this);
    }

    render() {
        let { report, t } = this.props;

        if(!report)
            return t('Report not found');

        return (
            <div className="MessageReportHandler">
                <div className="MessageReportHandler__Content">
                    <div className="button-line">
                        <button className="ant-btn ant-btn-secondary report-button" onClick={this.goBack}>{t('back')}</button>
                        <button disabled={report.statusId !== ACTIVE} className="ant-btn ant-btn-secondary report-button" onClick={this.markAsResolved}>{t('Mark as resolved')}</button>
                        <button disabled={report.message.statusId !== MESSAGE_SENT} className="ant-btn ant-btn-primary report-button" onClick={this.deleteAssociatedMessage}>{t('Delete associated message')}</button>
                        <a className="ant-btn ant-btn-primary report-button" target="_blank" href={"https://fundky.com/en/dashboard/members/" + report.sender.id}>
                        <FontAwesomeIcon icon={['fal', 'external-link']} /> {t('See sender page')}</a>
                    </div>

                    <div>
                        <div className="report-line"><b className="report-line-field">{t('Reported By')}:</b> <span>{report.reporter.name}</span></div>
                        <div className="report-line"><b className="report-line-field">{t('Reported On')}:</b> <span>{report.reportedOn}</span></div>
                        <div className="report-line"><b className="report-line-field">{t('Reason')}:</b></div>
                        <div className="report-line"><p className="report-line-field">{report.reason}</p></div>
                        <div className="report-line"><b className="report-line-field">{t('Message Content')}:</b></div>
                        <div className="report-line"><div className="report-line-field" dangerouslySetInnerHTML={{ __html: sanitizeHTML(report.message.content, SANITIZE_HTML_CONFIG) }} /></div>
                    </div>
                </div>
            </div>
        );
    }

    goBack() {
        this.props.history.push(`/${this.props.locale}/d/messages/reports`)
    }

    markAsResolved() {
        this.props.resolveReport(this.props.report.id).then((e) => {
            if(e.type === RESOLVE_REPORT_SUCCESS)
                this.goBack();
        });
    }

    deleteAssociatedMessage() {
        this.props.updateMessage(this.props.report.message.id, ARCHIVED).then((e) => {
            if(e.type === UPDATE_MESSAGE_SUCCESS)
                this.goBack();
        })
    }
}

export default translate('MessageReportHandler')(MessageReportHandler);